import { Menu, MenuButton, IconButton, MenuList, MenuItem, Box, Text } from "@chakra-ui/react";
import { GlobeIcon, CheckIcon } from "@iloq/shared-react/CustomIcons";
import { ReactNode } from "react";
import { useIntl } from "react-intl";

const allLangs = [
  {
    languageCode: "en",
    languageDisplay: "English",
  },
  {
    languageCode: "fi",
    languageDisplay: "Suomi",
  },
  {
    languageCode: "de",
    languageDisplay: "Deutsch",
  },
  {
    languageCode: "sv",
    languageDisplay: "Svenska",
  },
  {
    languageCode: "nl",
    languageDisplay: "Nederlands",
  },
  {
    languageCode: "da",
    languageDisplay: "Dansk",
  },
  {
    languageCode: "fr",
    languageDisplay: "Français",
  },
  {
    languageCode: "es",
    languageDisplay: "Español",
  },
  {
    languageCode: "nb",
    languageDisplay: "Norsk",
  },
];

export function LocaleChanger({ setLocale }: { setLocale: (locale: string) => void }): ReactNode {
  const intl = useIntl();

  const handleLanguageChange = (lang: string): void => {
    if (lang === intl.locale) {
      return; // No change if the selected language is already active
    }

    setLocale(lang);
    localStorage.setItem("unauthenticated-language", lang);
  };

  return (
    <Menu>
      <MenuButton
        as={IconButton}
        icon={<GlobeIcon boxSize="2rem" />}
        variant="ghost"
        aria-label="Select Language"
      />
      <MenuList>
        {allLangs.map((lang) => (
          <MenuItem key={lang.languageCode} onClick={() => handleLanguageChange(lang.languageCode)}>
            <Box>
              <img
                src={`/img/languages/${lang.languageCode}.png`}
                alt={`${lang.languageDisplay} flag`}
                style={{ width: "20px", height: "20px", marginRight: "8px" }}
              />
            </Box>
            <Text>{lang.languageDisplay}</Text>
            {lang.languageCode === intl.locale && (
              <Box ml="auto">
                <CheckIcon boxSize="1rem" />
              </Box>
            )}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
